<template>
  <q-drawer
    dark
    :show-if-above="!enableMobileDisplay"
    v-model="drawerLeft"
    side="left"
    class="left-sidebar column"
    behavior="desktop"
    :width="232"
    :breakpoint="500"
    :mini="miniState"
    :mini-width="72"
  >
    <q-list class="app-menu">
      <q-item data-nosnippet>
        <q-item-section avatar>
          <q-btn
            round
            flat
            icon="sym_r_menu"
            @click="
              () => {
                toggleMiniState();
              }
            "
            :ripple="false"
            style="margin-right: -2px"
          />
        </q-item-section>
        <q-item-section data-nosnippet>
          <div class="flex items-center no-wrap">
            <div class="text-weight-bold" data-nosnippet>Menu</div>
            <q-space />
            <q-btn
              flat
              round
              icon="sym_r_close"
              color="text-background-very-light"
              @click="
                () => {
                  toggleMiniState();
                }
              "
            />
          </div>
        </q-item-section>
      </q-item>

      <q-item to="/" :active="$route.path == '/'">
        <q-item-section avatar>
          <q-avatar icon="sym_r_home" size="43px" />
          <q-tooltip v-if="miniState" anchor="center right" self="center left">
            Your Dashboard
          </q-tooltip>
        </q-item-section>
        <q-item-section>
          Your Dashboard
        </q-item-section>
      </q-item>

      <q-item to="/search" :active="$route.path.includes('/search')">
        <q-item-section avatar>
          <q-avatar icon="sym_r_search" size="43px" />
          <q-tooltip v-if="miniState" anchor="center right" self="center left">
            Search Vehicles
          </q-tooltip>
        </q-item-section>
        <q-item-section>
          Search Vehicles
        </q-item-section>
      </q-item>

      <q-item to="/watchlist" :active="$route.path.includes('/watchlist')">
        <q-item-section avatar>
          <q-avatar icon="sym_r_star" size="43px" />
          <q-tooltip v-if="miniState" anchor="center right" self="center left">
            Your Watchlist
          </q-tooltip>
        </q-item-section>
        <q-item-section>
          Your Watchlist
        </q-item-section>
      </q-item>

      <!--<q-item to="/inquiries" :active="$route.path.includes('/inquiries')">
        <q-item-section avatar>
          <q-avatar icon="sym_r_forum" size="43px" />
          <q-tooltip v-if="miniState" anchor="center right" self="center left">
            Your Inquiries
          </q-tooltip>
        </q-item-section>
        <q-item-section>
          Your Inquiries
        </q-item-section>
      </q-item>-->
    </q-list>
  </q-drawer>
</template>

<script>
export default {
  name: "TheMenuSidebar",
  data() {
    return {
      drawerLeft: this.windowWidth > 769,
      miniState: true,
      miniStateTimeout: null
    };
  },
  watch: {
    enableMobileDisplay(val) {
      this.drawerLeft = !val;
    }
  },
  methods: {
    toggleMiniState() {
      this.miniState = !this.miniState;
    },
    toggleMiniStateViaMouse(mouseDirection) {
      clearTimeout(this.miniStateTimeout);
      this.miniStateTimeout = setTimeout(() => {
        if (mouseDirection === "enter") {
          this.miniState = false;
        } else {
          this.miniState = true;
        }
      }, 100);
    }
  }
};
</script>

<style lang="scss">
.left-sidebar {
  color: #fff;
  background: color(background, very-light);
  box-shadow: $shadow-bottom;

  .app-menu {
    .q-item {
      height: 66px;
      font-size: 14px;
    }
    a.q-item.q-link {
      // border-radius: 0 10px 10px 0;
      // margin-right: $space-md;
      height: 66px;

      &.q-router-link--active {
        font-weight: 700;
        border-left: 4px solid color(secondary);
        background: rgba(231, 23, 27, 0.22);

        > .q-focus-helper {
          background: currentColor;
          opacity: 0.1;
        }

        .q-avatar {
          color: white;
          background: color(secondary);
          box-shadow: $shadow-bottom;
          margin-left: -4px;
        }
      }
    }

    .q-item__section--avatar {
      .q-avatar {
        height: 1em;
        width: 1em;
        background: color(background, very-very-light);
        color: color(text);
      }
    }

    .q-expansion-item--expanded {
      > div {
        > .q-item {
          > .q-item__section--main {
            font-weight: 700;
          }
        }
      }
    }
  }

  + .q-layout__shadow:after {
    box-shadow: 0 0 10px 2px rgb(0 0 0 / 10%), 0 0px 10px rgb(0 0 0 / 14%) !important;
  }

  .--inset-level-1 {
    padding-left: 54px;
  }
  .--inset-level-2 {
    padding-left: 100px;
  }
}
</style>
